import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { TyreDiscountsDashboardQueryKeys } from "modules/TyreDiscountsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { TyreDiscount } from "models";

export const useUpdateTyreDiscountMutation = () =>
  useTypedMutation<TyreDiscount, void>({
    mutationFn: async (payload: TyreDiscount) => (await ApiInstance.post("/tyre_discounts/update", payload, ENV.dealerBaseURL)).data,
    onSuccess: payload => {
      const discounts = typedQueryClient.getQueryData(TyreDiscountsDashboardQueryKeys.discounts);
      if (!discounts) return;

      const discountIdx = discounts.findIndex(discount => discount.id === payload.id);
      if (discountIdx === -1) return;

      typedQueryClient.setQueryData(TyreDiscountsDashboardQueryKeys.discounts, discounts.with(discountIdx, payload));
    }
  });
